import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

// Opens Razorpay Checkout for a booking's order, verifies server-side, then calls onPaid(confirmedBooking).
export function payWithRazorpay(b, onPaid) {
  if (!window.Razorpay) return toast.error("Payment window didn't load. Please refresh and try again.");
  new window.Razorpay({
    key: b.payment.key_id,
    amount: b.amount * 100,
    currency: "INR",
    name: "JawaiTrails",
    description: `${b.title || "Safari booking"} · ${b.booking_ref}`,
    order_id: b.payment.order_id,
    prefill: { name: b.guest_name, email: b.guest_email, contact: b.guest_mobile },
    notes: { booking_ref: b.booking_ref },
    theme: { color: "#1E3A2B" },
    handler: async (res) => {
      try {
        const { data } = await api.post(`/bookings/${b.id}/verify-payment`, {
          razorpay_order_id: res.razorpay_order_id,
          razorpay_payment_id: res.razorpay_payment_id,
          razorpay_signature: res.razorpay_signature,
        });
        toast.success("Payment verified · booking confirmed");
        onPaid(data);
      } catch (e) { toast.error(formatErr(e)); }
    },
    modal: { ondismiss: () => toast("Payment not completed. Your booking is held for 15 minutes, or you can pay later from Find My Booking.") },
  }).open();
}
